var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAttachmentFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.152,
    height: 19.803,
    viewBox: "0 0 18.152 19.803",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.225,118.641a3.514,3.514,0,0,1-3.51-3.51v-8.464H2.271A2.273,2.273,0,0,0,0,108.939v11.148a2.273,2.273,0,0,0,2.271,2.271H12.593a2.273,2.273,0,0,0,2.271-2.271v-1.445Zm0,0",
    transform: "translate(0 -102.555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.279,2.111A2.11,2.11,0,0,0,138.169,0h-8.058A2.11,2.11,0,0,0,128,2.111V11.7a2.11,2.11,0,0,0,2.111,2.111h8.058a2.11,2.11,0,0,0,2.11-2.111Zm0,0",
    transform: "translate(-122.127)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAttachmentFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_attachmentFile.4787e442dc120c575aad99527d8a5ab4.svg";